import { render, staticRenderFns } from "./IconSaveAsOutline.vue?vue&type=template&id=513aa0b6"
import script from "./IconSaveAsOutline.vue?vue&type=script&lang=js"
export * from "./IconSaveAsOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports